import { createUseStyles } from "react-jss";
import { colors } from "../../../constants/colors";
import { breakpoints } from "../../../constants/breakpoints";

const styles = createUseStyles({
  bodyWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  bodyContainer: {
    width: "70vw",
    marginTop: "32px",
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      width: "100%",
      padding: "0px 60px",
    },
    [`@media (max-width: ${breakpoints.md}px)`]: {
      width: "100%",
      padding: "0px 20px",
    },
  },
  inputAutocomplete: {
    fontSize: "16px",
    fontWeight: "500",
    lineHeight: "24px",
    color: colors.lightBlack,
    width: "30vw",
    minWidth: "300px",
    maxWidth: "400px",
    padding: "0 0 0 42px",
    textOverflow: "ellipsis",
    "&::placeholder": {
      fontWeight: "400",
    },
    [`@media (max-width: ${breakpoints.md}px)`]: {
      width: "100%",
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "100%",
      minWidth: "none",
      maxWidth: "none",
    },
  },
  autocompleteOptions: {
    position: "absolute",
    top: 48,
    background: colors.white,
    border: "1px solid " + colors.lightGrey,
    borderRadius: "8px",
    width: "100%",
    zIndex: 2,
    padding: "16px 14px 18px 14px",
    color: colors.mediumGrey,
    maxHeight: "230px",
    overflowY: "auto",
    boxShadow:
      "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)",
    overflowX: "hidden",
    "& p": {
      display: "flex",
      alignItems: "center",
      fontSize: "16px",
      fontWeight: "400",
      padding: "8px",
      minHeight: "44px",
      margin: 0,
      wordWrap: "wrap",
    },
    "& ul": {
      margin: "-8px -6px",
      padding: "0px",
    },
    "& li": {
      display: "flex",
      alignItems: "center",
      listStyleType: "none",
      paddingLeft: "6px",
      minHeight: "44px",
      fontSize: "16px",
      fontWeight: "500",
      borderRadius: "6px",
      color: colors.lightBlack,
      "&:hover": {
        background: colors.brightBlue,
      },
      "& a": {
        width: "100%",
        padding: "14px 12px",
      },
    },
    "& span": {
      fontSize: "16px",
      fontWeight: "500",
      lineHeight: "24px",
      color: colors.lightBlack,
      marginLeft: "8px",
    },
    "& label": {
      cursor: "pointer",
    },
  },
  assignHeader: {
    display: "flex",
    justifyContent: "space-between",
    "& h1": {
      fontSize: "30px",
      lineHeight: "38px",
      fontWeight: "600",
      color: colors.lightBlack,
      marginBottom: "12px",
    },
    "& p": {
      fontSize: "16px",
      lineHeight: "24px",
      fontWeight: "400",
      color: colors.inactiveGrey,
      margin: 0,
    },
    [`@media (max-width: ${breakpoints.md}px)`]: {
      flexDirection: "column",
    },
  },
  redeemBtn: {
    height: "fit-content",
    width: "fit-content",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: "600",
    border: "none",
    padding: "10px 18px",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      marginTop: "20px",
    },
  },
  divider: {
    color: colors.lightGrey,
    opacity: "1",
    margin: "20px 0px 32px",
  },
  balanceContainer: {
    display: "flex",
    justifyContent: "space-between",
    gap: "20px",
    "& h6": {
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "20px",
      color: colors.grey,
      marginBottom: "6px",
    },
    [`@media (max-width: ${breakpoints.md}px)`]: {
      flexDirection: "column",
    },
  },
  balanceWrapper: {
    width: "30vw",
    minWidth: "350px",
    maxWidth: "400px",
    backgroundColor: colors.blueLight25,
    borderRadius: "12px",
    padding: "17px 16px",
    "& .progress": {
      marginTop: "8px",
      height: "8px",
      backgroundColor: colors.blue100,
    },
    "& .progress-bar": {
      borderRadius: "4px",
      backgroundColor: colors.blue700,
    },
    "& p": {
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "20px",
      color: colors.blue900,
      margin: 0,
    },
    "& span": {
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
      color: colors.blue700,
      marginBottom: 0,
    },
    [`@media (max-width: ${breakpoints.md}px)`]: {
      width: "100%",
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "100%",
      minWidth: "none",
      maxWidth: "none",
    },
  },
  balanceWrapperRed: {
    extend: "balanceWrapper",
    backgroundColor: colors.veryLightRed,
    "& .progress": {
      backgroundColor: colors.pinkRed,
    },
    "& .progress-bar": {
      backgroundColor: colors.darkRed,
    },
    "& p": {
      color: colors.error900,
    },
    "& span": {
      color: colors.darkRed,
    },
  },
  balanceText: {
    display: "flex",
    justifyContent: "space-between",
    gap: "10px"
  },
  assignSearchbox: {
    width: "30vw",
    minWidth: "300px",
    maxWidth: "400px",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      width: "100%",
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "100%",
      minWidth: "none",
      maxWidth: "none",
    },
    "& div": {
      maxWidth: "none",
    },
    "& p": {
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
      color: colors.mediumGrey,
      margin: "8px 0px 0px",
    },
  },
  assignGrid: {
    marginTop: "24px",
    "& > div:first-child": {
      padding: 0,
    },
    "& .rdt_TableRow": {
      "&:hover": {
        backgroundColor: colors.brightBlue,
      },
    },
    "& .rdt_TableCell:last-child": {
      paddingRight: "24px",
    },
    '& [class^="link"]': {
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "24px",
      color: colors.inactiveGrey,
    },
  },
  emptyGridWrapper: {
    padding: "0px 10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    margin: "48px 0px",
    maxWidth: "352px",
    "& h3": {
      fontSize: "16px",
      fontWeight: "600",
      lineHeight: "24px",
      color: colors.lightBlack,
      marginBottom: "4px",
      marginTop: "16px",
    },
    "& p": {
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
      color: colors.mediumGrey,
      marginBottom: 0,
    },
  },
  awardTierText: {
    display: "flex",
    alignItems: "center",
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "20px",
    color: colors.grey,
    "& svg": {
      marginLeft: "12px",
    },
  },
  awardTierBtn: {
    backgroundColor: colors.primary50Blue,
    color: colors.primary700Blue,
    padding: "8px 14px",
    "&:hover": {
      backgroundColor: colors.primary75Blue,
    },
  },
  advantagePointText: {
    fontSize: "16px",
    fontWeight: "400",
    lineHeight: "24px",
    color: colors.inactiveGrey,
  },
  deleteBtn: {
    padding: "7px",
    cursor: "pointer",
    "& path": {
      stroke: colors.error600,
    },
    "&:hover": {
      backgroundColor: colors.lightRed,
      borderRadius: "8px"
    },
  },
  nameWrapper: {
    display: "flex",
    minWidth: "100px",
  },
  initialsAvatar: {
    alignSelf: "center",
    width: "40px",
    height: "40px",
    background: colors.veryLightGrey,
    borderRadius: "200px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minWidth: "40px",
    "& span": {
      color: colors.mediumGrey,
      fontWeight: "500",
    },
  },
  details: {
    marginLeft: "12px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    "& p": {
      margin: 0,
      fontSize: "14px",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    "& p:first-child": {
      color: colors.lightBlack,
      fontWeight: "500",
      lineHeight: "20px",
    },
    "& p:last-child": {
      color: colors.mediumGrey,
      fontWeight: "400",
      lineHeight: "20px",
    },
  },
});

export default styles;
